let _ = require("ES/lib/lodash");

module.exports = function(ids_in_order, curr_selection, end_id){
	if(_.size(curr_selection) === 0 && _.includes(ids_in_order, end_id)){
		return [end_id];
	}
	let start_id = _.first(curr_selection);
	if(!_.includes(ids_in_order, start_id)){
		return [];
	}
	if(!_.includes(ids_in_order, end_id)){
		return curr_selection;
	}

	let start_i = ids_in_order.indexOf(start_id);
	let end_i = ids_in_order.indexOf(end_id);

	return start_i > end_i
		? ids_in_order.slice(end_i, start_i + 1).reverse()//We wan to reverse b/c next selection will preserve the starting id, thus making it feel more natural to the user
		: ids_in_order.slice(start_i, end_i + 1);
};



// WEBPACK FOOTER //
// ./src/components/main_view/event_area/tabs/action_list/rangeSelectIDs.js